import { GridSortModel, GridSortItem } from '@mui/x-data-grid-pro';

import { httpClient, HttpMethod } from './http-client';
import { ServiceTypeResponse, ServiceType, ServiceStatus } from '../@types/service.type';
import { isNotArrayEmpty } from '../utils/array-utils';

export const createServiceType = (nodeType: ServiceTypeResponse): Promise<ServiceTypeResponse> => {
  return httpClient<ServiceTypeResponse>('/serviceTypes', HttpMethod.Post, nodeType);
};

export const updateServiceType = (code: string, nodeType: ServiceTypeResponse): Promise<ServiceTypeResponse> => {
  return httpClient<ServiceTypeResponse>(`/serviceTypes/${code}`, HttpMethod.Put, nodeType);
};

export const getServiceTypeByCode = (code: string): Promise<ServiceTypeResponse> => {
  return httpClient<ServiceTypeResponse>(`/serviceTypes/${code}`, HttpMethod.Get);
};

export const getServiceTypeByCodeForServiceUpdate = (code: string): Promise<ServiceTypeResponse> => {
  return httpClient<ServiceTypeResponse>(`/serviceTypes/${code}/serviceUpdate`, HttpMethod.Get);
};

export const getServiceTypes = (sortModel?: GridSortModel): Promise<ServiceTypeResponse[]> => {
  let url = '/serviceTypes';
  if (sortModel && isNotArrayEmpty(sortModel as GridSortItem[], 0)) {
    url += `?order_by=${sortModel[0]?.field}&order_direction=${sortModel[0]?.sort}`;
  }
  return httpClient<ServiceTypeResponse[]>(url, HttpMethod.Get);
};

export const getServiceTypeAvailableStatuses = (serviceTypes: ServiceType[] | { serviceTypes: string[] }): Promise<ServiceStatus[]> => {
  return httpClient<ServiceStatus[]>('/serviceTypes/nextStatuses', HttpMethod.Post, serviceTypes);
};